import React, { useState } from 'react';
import { KeyIcon, ExternalLinkIcon } from 'lucide-react';
import { Input } from '../ui/Input';
import { Button } from '../ui/Button';
import { setStoredApiKey, clearStoredApiKey } from '../../lib/interiorAI/apiKeyStore';
interface ApiKeyPanelProps {
  apiKey: string;
  onApiKeyChange: (key: string) => void;
}
export function ApiKeyPanel({
  apiKey,
  onApiKeyChange
}: ApiKeyPanelProps) {
  const [draft, setDraft] = useState(apiKey);
  const [isOpen, setIsOpen] = useState(!apiKey);
  const handleSave = () => {
    const trimmed = draft.trim();
    setStoredApiKey(trimmed);
    onApiKeyChange(trimmed);
    if (trimmed) setIsOpen(false);
  };
  const handleClear = () => {
    clearStoredApiKey();
    setDraft('');
    onApiKeyChange('');
  };
  return <div className="border border-gray-100 rounded-2xl bg-gray-50/60" data-id="element-194" data-mp="1xo7cd2qiuryx">
      <button type="button" onClick={() => setIsOpen(v => !v)} className="w-full flex items-center justify-between gap-3 text-left p-5" data-id="element-195" data-mp="3dyt7yzx57yc3">
        <div className="flex items-center gap-3 min-w-0" data-id="element-196" data-mp="24ytm3v5efsf7">
          <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${apiKey ? 'bg-emerald-100' : 'bg-amber-100'}`} data-id="element-197" data-mp="250eh1lvmlddl">
            <KeyIcon className={`w-4 h-4 ${apiKey ? 'text-emerald-600' : 'text-amber-600'}`} data-id="element-198" data-mp="2ewrbwn2wpx9x" />
          </div>
          <div className="min-w-0" data-id="element-199" data-mp="2jujce5hmarpq">
            <p className="text-sm font-bold text-apple-black" data-id="element-200" data-mp="1m7sq9fzksczv">Gemini API pripojenie</p>
            <p className="text-xs text-apple-gray truncate" data-id="element-201" data-mp="1r6n7idhw9thv">
              {apiKey ? 'Pripojené — reálne AI generovanie aktívne' : 'Nepripojené — beží demo režim'}
            </p>
          </div>
        </div>
        <span className="text-xs font-semibold text-apple-blue flex-shrink-0" data-id="element-202" data-mp="20wglfl5iekpa">
          {isOpen ? 'Skryť' : 'Nastaviť'}
        </span>
      </button>

      {isOpen && <div className="px-5 pb-5 pt-1 border-t border-gray-200 space-y-4" data-id="element-203" data-mp="13eymli7ek7ay">
          <Input label="Gemini API kľúč" type="password" placeholder="AIzaSy..." value={draft} onChange={e => setDraft(e.target.value)} helperText="Kľúč sa ukladá iba lokálne v tvojom prehliadači a nikdy neopúšťa toto zariadenie." data-id="element-204" data-mp="18ekz1pfepjip" />
          <div className="flex flex-wrap items-center gap-3" data-id="element-205" data-mp="1a4hsx5n5pa3e">
            <Button size="small" onClick={handleSave} className="!bg-apple-blue hover:!bg-apple-blueHover !text-white !rounded-full !border-none" data-id="element-206" data-mp="1577r0qikz5yo">
              Uložiť kľúč
            </Button>
            {apiKey && <Button size="small" variant="secondary" onClick={handleClear} className="!rounded-full" data-id="element-207" data-mp="rei2aebo3mxv">
                Odpojiť
              </Button>}
            <a href="https://aistudio.google.com/apikey" target="_blank" rel="noopener noreferrer" className="text-xs font-semibold text-apple-blue flex items-center gap-1 hover:underline" data-id="element-208" data-mp="mhrro6imtjju">
              Získať bezplatný kľúč <ExternalLinkIcon className="w-3 h-3" data-id="element-209" data-mp="25cs3c1261hnp" />
            </a>
          </div>
        </div>}
    </div>;
}